"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XRATBFDXcjs = require('./XRATBFDX.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/group/group.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useGroup2(props) {
    const [labelId, setLabelId] = _react.useState.call(void 0, );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XRATBFDXcjs.GroupLabelContext.Provider, { value: setLabelId, children: element }),
      []
    );
    props = {
      role: "group",
      "aria-labelledby": props["aria-label"] != null ? void 0 : labelId,
      ...props
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var Group = _PTOCUU2Dcjs.forwardRef.call(void 0, function Group2(props) {
  const htmlProps = useGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useGroup = useGroup; exports.Group = Group;
